// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-popup-wrapper {
  cursor: pointer;

  position: fixed;
  z-index: 999997;
  bottom: 90px;
  
  overflow: hidden;

  width: fit-content;
  max-width: 270px;
  padding: 16px 20px;

  background: #FFF;
  box-shadow: 0 0 24px rgb(0 0 0 / 12%);
  
  transition: width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s,
    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s;
}
  
.widget-popup-wrapper-hidden {
  opacity: 0;
}

.widget-popup-wrapper-hidden.widget-popup-wrapper-right {
  transform: scale(0) translate(100%, 100%);
}

.widget-popup-wrapper-hidden.widget-popup-wrapper-left {
  transform: scale(0) translate(-100%, 100%);
}
  
.widget-popup-wrapper-shown {
  transform: scale(1) translate(0, 0);
  opacity: 1;
}

.widget-popup-wrapper-right {
  right: 90px;
  border-radius: 16px 16px 6px;
}

.widget-popup-wrapper-left {
  left: 90px;
  border-radius: 16px 16px 16px 6px;
}

.widget-popup-wrapper button {
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 21px;
  padding: 0;

  visibility: hidden;
  opacity: 0.5;
  background: 0 0;
  border: 0;

  transition: visibility 0.3s;
}

.widget-popup-wrapper button:hover {
  opacity: 1;
}

.widget-popup-wrapper:hover button {
  visibility: visible;
}

.widget-popup-title, .widget-popup-text {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.widget-popup-title span, .widget-popup-text span {
  font-family: Inter, sans-serif;
  font-style: normal;
  overflow-wrap: break-word;
}

.widget-popup-title {
  align-items: center;
  margin-bottom: 6px;
}

.widget-popup-title span {
  font-size: 12px;
  font-weight: 500;
  line-height: 21px;
  color: #8C8C8C;
}

.widget-popup-text span {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #262732;
}

@media (height <= 700px) {
  .widget-popup-wrapper {
    bottom: 60px
  }

  .widget-popup-wrapper-right {
    right: 60px;
  }
  
  .widget-popup-wrapper-left {
    left: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/popUp/popUp.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf,eAAe;EACf,eAAe;EACf,YAAY;;EAEZ,gBAAgB;;EAEhB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;;EAElB,gBAAgB;EAChB,qCAAqC;;EAErC;2EACyE;AAC3E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,UAAU;;EAEV,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,SAAS;;EAET,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".widget-popup-wrapper {\n  cursor: pointer;\n\n  position: fixed;\n  z-index: 999997;\n  bottom: 90px;\n  \n  overflow: hidden;\n\n  width: fit-content;\n  max-width: 270px;\n  padding: 16px 20px;\n\n  background: #FFF;\n  box-shadow: 0 0 24px rgb(0 0 0 / 12%);\n  \n  transition: width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s,\n    transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s;\n}\n  \n.widget-popup-wrapper-hidden {\n  opacity: 0;\n}\n\n.widget-popup-wrapper-hidden.widget-popup-wrapper-right {\n  transform: scale(0) translate(100%, 100%);\n}\n\n.widget-popup-wrapper-hidden.widget-popup-wrapper-left {\n  transform: scale(0) translate(-100%, 100%);\n}\n  \n.widget-popup-wrapper-shown {\n  transform: scale(1) translate(0, 0);\n  opacity: 1;\n}\n\n.widget-popup-wrapper-right {\n  right: 90px;\n  border-radius: 16px 16px 6px;\n}\n\n.widget-popup-wrapper-left {\n  left: 90px;\n  border-radius: 16px 16px 16px 6px;\n}\n\n.widget-popup-wrapper button {\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 21px;\n  padding: 0;\n\n  visibility: hidden;\n  opacity: 0.5;\n  background: 0 0;\n  border: 0;\n\n  transition: visibility 0.3s;\n}\n\n.widget-popup-wrapper button:hover {\n  opacity: 1;\n}\n\n.widget-popup-wrapper:hover button {\n  visibility: visible;\n}\n\n.widget-popup-title, .widget-popup-text {\n  display: flex;\n  gap: 10px;\n  justify-content: space-between;\n}\n\n.widget-popup-title span, .widget-popup-text span {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  overflow-wrap: break-word;\n}\n\n.widget-popup-title {\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.widget-popup-title span {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 21px;\n  color: #8C8C8C;\n}\n\n.widget-popup-text span {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #262732;\n}\n\n@media (height <= 700px) {\n  .widget-popup-wrapper {\n    bottom: 60px\n  }\n\n  .widget-popup-wrapper-right {\n    right: 60px;\n  }\n  \n  .widget-popup-wrapper-left {\n    left: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
